import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import { ITINERARY_CHANGE_ROUTE_ENDPOINT } from '../../config/endpoints';
import { DEFAULT_GET_CONFIG, DEFAULT_POST_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  CLEAR_ITINERARY_CHANGE_ROUTE,
  CLEAR_ITINERARY_CHANGE_ROUTES,
  FLAG_GETTING_ITINERARY_CHANGE_ROUTES,
  FLAG_ITINERARY_CHANGE_ROUTE_ACTIVITY,
  GET_ITINERARY_CHANGE_ROUTE,
  GET_ITINERARY_CHANGE_ROUTES,
} from '../types';
import { ITINERARY_CHANGE_ROUTE_PATH } from '../../config/paths';

const flagGettingItineraryChangeRoutes = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_ITINERARY_CHANGE_ROUTES,
    payload: flag,
  });

const clearItineraryChangeRoutes = () => (dispatch) =>
  dispatch({
    type: CLEAR_ITINERARY_CHANGE_ROUTES,
  });

const flagItineraryChangeRouteActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_ITINERARY_CHANGE_ROUTE_ACTIVITY,
    payload: flag,
  });

const clearItineraryChangeRoute = () => (dispatch) =>
  dispatch({
    type: CLEAR_ITINERARY_CHANGE_ROUTE,
  });

const getItineraryChangeRoutes = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingItineraryChangeRoutes(true));

    const query = QueryString.stringify(tableFilters);

    const endpoint = ITINERARY_CHANGE_ROUTE_ENDPOINT;

    const url = `${endpoint}?${query}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const itinerarySchedules = await response.json();
    dispatch({
      type: GET_ITINERARY_CHANGE_ROUTES,
      payload: itinerarySchedules,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingItineraryChangeRoutes(false));
  }
};

const postItineraryChangeRoute =
  async ({ newRouteId, newCircuitId, comment, serviceTypeId, itineraryIds }) =>
  async (dispatch) => {
    try {
      dispatch(flagItineraryChangeRouteActivity(true));

      const payload = {
        newCircuitId,
        newRouteId,
        comment,
        serviceTypeId,
        itineraryIds,
      };

      const url = ITINERARY_CHANGE_ROUTE_ENDPOINT;

      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });

      await isErrorResponse(response, null, dispatch);

      const itineraryChangeRoute = await response.json();

      dispatch(
        push(`${ITINERARY_CHANGE_ROUTE_PATH}/${itineraryChangeRoute.id}`),
      );
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagItineraryChangeRouteActivity(false));
    }
  };

const getItineraryChangeRoute =
  async ({ itineraryChangeRouteId }) =>
  async (dispatch) => {
    try {
      dispatch(flagItineraryChangeRouteActivity(true));
      const url = `${ITINERARY_CHANGE_ROUTE_ENDPOINT}/${itineraryChangeRouteId}`;
      const response = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(response, null, dispatch);
      const itinerary = await response.json();
      dispatch({
        type: GET_ITINERARY_CHANGE_ROUTE,
        payload: itinerary,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagItineraryChangeRouteActivity(false));
    }
  };

export {
  clearItineraryChangeRoute,
  clearItineraryChangeRoutes,
  getItineraryChangeRoute,
  getItineraryChangeRoutes,
  postItineraryChangeRoute,
};
